import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/auth-context";
import { Loader2 } from "lucide-react";

export default function AuthCallbackPage() {
  const { session, isLoading } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectParam = searchParams.get("redirect");
  const safeRedirect =
    redirectParam &&
    redirectParam.startsWith("/") &&
    !redirectParam.startsWith("//")
      ? redirectParam
      : "/dashboard";

  useEffect(() => {
    if (isLoading) return;

    if (session) {
      navigate(safeRedirect, { replace: true });
    } else {
      // Give the auth state change listener a moment to process the callback.
      // If no session after a short delay, redirect to login with an error.
      const timeout = setTimeout(() => {
        navigate("/login", {
          replace: true,
          state: { message: "Authentication failed. Please try again." },
        });
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [session, isLoading, navigate, safeRedirect]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      <p className="text-sm text-muted-foreground">Completing sign in...</p>
    </div>
  );
}
